import downloadFileFromDatalake from '@/shared/lib/download/downloadFileFromDatalake';
import { triggerBlobDownload } from '@/shared/lib/download/triggerBlobDownload';

const downloadFile = async (fileId: string, fileName: string, maxRetries = 3) => {
  let lastError: unknown;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const fileResponse = await downloadFileFromDatalake(fileId);
      triggerBlobDownload(fileResponse.data, fileName);
      return;
    } catch (error) {
      lastError = error;
      if (attempt < maxRetries)
        // eslint-disable-next-line no-await-in-loop
        await new Promise<void>(resolve => {
          setTimeout(resolve, 500);
        });
    }
  }

  throw lastError instanceof Error ? lastError : new Error('Error downloading file');
};

export default downloadFile;
